import { useState } from "react";
import "./sucursales.css";

const regions = [
  {
    id: "cuyo",
    name: "CUYO",
    branches: [
      {
        city: "Mendoza",
        lines: [
          "Complejo logístico Andreu Nave E1",
          "Acceso Sur km 14 Lujan de Cuyo.",
          "C.P.: 5507",
          "Cel.: +54 2613 172 708",
        ],
      },
      {
        city: "San Rafael",
        lines: [
          "Base Patricias Mendocinas N° 550.",
          "C.P.: 5602",
          "Cel.: +542613172708",
        ],
      },
      {
        city: "San Luis",
        lines: ["Ayacucho N° 1625", "C.P.: 5700", "Cel.: +542664822400"],
      },
      {
        city: "San Juan",
        lines: [
          "Pueyrredon N° 190 Sur, Santa Lucía.",
          "CP: 5400",
          "Cel.: +542646992504",
        ],
      },
      {
        city: "La Rioja",
        lines: [
          "Ruta Nacional N° 38 Km 26 y 1/2",
          "C.P.: 5300",
          "Cel.: +543804236429",
        ],
      },
    ],
  },
  {
    id: "mdq",
    name: "MAR DEL PLATA",
    branches: [
      {
        city: "Mar del Plata",
        lines: ["9 de Julio N° 6115", "C.P.: 7600", "Cel.: +542235047354"],
      },
    ],
  },
  {
    id: "litoral",
    name: "LITORAL",
    branches: [
      {
        city: "Concordia",
        lines: ["Monseñor Rosch N°5005", "Cel.: +543455032600"],
      },
      {
        city: "Concepción del Uruguay",
        lines: ["Dr. Uncal N° 814", "Cel.: +543442470296"],
      },
      {
        city: "Paraná",
        lines: ["Rondeau N° 1330", "Cel.: +543433022800"],
      },
    ],
  },
  {
    id: "nea",
    name: "NORDESTE ARGENTINO",
    branches: [
      {
        city: "Resistencia",
        lines: ["Ruta 11 KM 1001", "C.P.: 3500", "Cel.: +543482201469"],
      },
      {
        city: "Reconquista",
        lines: ["Ruta 11 Km 785", "CP: 3560", "Cel.: +543482721119"],
      },
      {
        city: "Posadas",
        lines: [
          "Av. Bustamante 4835 casi Av. Aguado.",
          "CP: 3300",
          "Cel.: +543765160012",
        ],
      },
      {
        city: "Formosa",
        lines: ["Av. Gendarmería Nacional N°", "Cel.: +543625550012"],
      },
      {
        city: "Paso de los Libres",
        lines: ["Madariaga 1445", "CP: 3230"],
      },
    ],
  },
];

const ChevronIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Sucursales = () => {
  const [openId, setOpenId] = useState("cuyo");

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section className="sucursales">
      <div className="sucursales-inner">
        <div className="accordion-list">
          {regions.map((region) => {
            const isOpen = openId === region.id;
            return (
              <div key={region.id} className={`accordion-item ${isOpen ? "is-open" : ""}`}>
                <button
                  className="accordion-header"
                  onClick={() => toggle(region.id)}
                  aria-expanded={isOpen}
                >
                  <span className="accordion-name">{region.name}</span>
                  <span className={`accordion-chevron ${isOpen ? "rotated" : ""}`}>
                    <ChevronIcon />
                  </span>
                </button>
                <div className="accordion-body" aria-hidden={!isOpen}>
                  <div className="branches-grid">
                    {region.branches.map((branch) => (
                      <div key={branch.city} className="branch-card">
                        <p className="branch-city">{branch.city}</p>
                        {branch.lines.map((line, i) => (
                          <p key={i} className="branch-line">{line}</p>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sucursales;
